import { addDays, addMonths, addWeeks, startOfDay, startOfMonth } from "date-fns/esm";

import CalendarViewMode from "@app/enum/CalendarViewMode";
import { getWeekStart } from "@app/util/dates";

export const getPreviousTimeframeStart = (currentStart: Date, viewMode: CalendarViewMode): Date => {
  switch (viewMode) {
    case CalendarViewMode.DAY:
      return addDays(currentStart, -1);
    case CalendarViewMode.MONTH:
      return addMonths(currentStart, -1);
    case CalendarViewMode.WEEK:
      return addWeeks(currentStart, -1);
  }
};

export const getNextTimeframeStart = (currentStart: Date, viewMode: CalendarViewMode): Date => {
  switch (viewMode) {
    case CalendarViewMode.DAY:
      return addDays(currentStart, 1);
    case CalendarViewMode.MONTH:
      return addMonths(currentStart, 1);
    case CalendarViewMode.WEEK:
      return addWeeks(currentStart, 1);
  }
};

export const getTimeframeStartForDate = (
  viewMode: CalendarViewMode,
  day: Date | number = Date.now()
): Date => {
  switch (viewMode) {
    case CalendarViewMode.DAY:
      return startOfDay(day);
    case CalendarViewMode.MONTH:
      return startOfMonth(day);
    case CalendarViewMode.WEEK:
      return getWeekStart(day);
  }
};
